import { isWeb, shadowStandard, SizableText, SmartLink, Stack, YStack } from '@my/ui'
import { CollectionOffersQueryOutput } from './queries'
import { LinearGradient } from '@tamagui/linear-gradient'
import { SolitoImage } from 'solito/image'

export type CollectionGridItemProps = {
  imagePriority?: boolean
} & CollectionOffersQueryOutput['Offers']['docs'][0]

export const CollectionGridItem = (props: CollectionGridItemProps) => {
  return (
    <YStack flex={1} position="relative" bg="$white" br="$3" overflow="hidden" {...shadowStandard}>
      <Stack pos="absolute" flex={1} overflow="hidden" w="100%" h="100%">
        <SolitoImage
          src={props?.featuredImage?.url}
          alt={props?.featuredImage?.alt || props.name}
          contentFit="cover"
          fill
          sizes="389px"
          priority={props.imagePriority}
        />
      </Stack>

      {isWeb ? (
        <div
          style={{
            backgroundImage: 'linear-gradient(0deg, rgba(0,0,0,.8), transparent)',
            position: 'absolute',
            width: '100%',
            height: '100%',
          }}
        />
      ) : (
        <LinearGradient
          width="100%"
          height="100%"
          position="absolute"
          bottom="$0"
          left="$0"
          colors={['$overlay13', '$overlay0']}
          start={[0, 1]}
          end={[0, 0]}
        />
      )}

      <SmartLink
        Component={YStack}
        flex={1}
        href={`/discounts/${props.brand.slug}/${props.slug}`}
        pressStyle={{
          opacity: 0.8,
        }}
        hoverStyle={{
          opacity: 0.9,
        }}
      >
        <YStack gap="$2" mt="auto" p={8} $gtXs={{ p: '$3.5' }}>
          <SizableText
            tag="h3"
            color="$white"
            size="$3"
            fow="600"
            numberOfLines={3}
            $gtXs={{
              size: '$8',
              lineHeight: '$7',
              fow: '600',
            }}
          >
            {props.name}
          </SizableText>
          {props.description && (
            <SizableText
              size="$2"
              numberOfLines={2}
              color="$white"
              $gtMd={{
                size: '$4',
              }}
            >
              {props.description}
            </SizableText>
          )}
        </YStack>
      </SmartLink>
    </YStack>
  )
}
